export default "__VITE_ASSET__BNk4IZp2__"